/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OverviewInputs */

const en_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const es_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción general`)
};

const fr_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const de_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

const ja_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

const ar_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظرة عامة`)
};

const id_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikhtisar`)
};

const it_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

const ru_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const pt_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão Geral`)
};

const ko_overview = /** @type {(inputs: OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개요`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {OverviewInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const overview = /** @type {((inputs?: OverviewInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OverviewInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overview(inputs)
	if (locale === "es") return es_overview(inputs)
	if (locale === "fr") return fr_overview(inputs)
	if (locale === "de") return de_overview(inputs)
	if (locale === "ja") return ja_overview(inputs)
	if (locale === "zh") return zh_overview(inputs)
	if (locale === "ar") return ar_overview(inputs)
	if (locale === "id") return id_overview(inputs)
	if (locale === "it") return it_overview(inputs)
	if (locale === "ru") return ru_overview(inputs)
	if (locale === "pt") return pt_overview(inputs)
	return ko_overview(inputs)
});